import { defineWithClassNames } from './internal'

export const spectre = defineWithClassNames()
